/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';
import {
  InterestLotTypes,
  MonitoringBiddingTypes,
  MonitoringState,
  MonitoredByTypes,
} from 'store/modules/monitoring_store/types';
import moment from 'moment';
import MonitoringPortals from 'services/monitoring_portals';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { useSelector } from 'react-redux';
import MonitoredByBalloon from 'components/atoms/monitored_by_balloon';
import MonitoredByCompanies from 'components/atoms/monitored_by_companies';
import companyId from 'services/company_id';
import TradingDropdown from 'components/atoms/trading_dropdown';
import { Container } from './styles';

interface TradingItemProps {
  trading: MonitoringBiddingTypes;
  toggleSelectedTrading: (tradingId: number) => void;
  isSelectedTrading: boolean;
  showMonitoredByBalloon: boolean;
  monitoredByList: Array<MonitoredByTypes>;
  tradingPosition: number;
  onCompaniesChanged: () => void;
}

const TradingItem = (props: TradingItemProps) => {
  const {
    trading,
    toggleSelectedTrading,
    isSelectedTrading,
    showMonitoredByBalloon,
    monitoredByList,
    tradingPosition,
    onCompaniesChanged,
  } = props;

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { monitoring } = useSelector<ApplicationState, MonitoringState>(
    (state) => state.storage.monitoring,
  );

  const sourceData = MonitoringPortals(profile.beta_tester).find(
    (portal) => portal.value === trading.source_id,
  );

  const [interestLots, setInterestLots] = useState<Array<InterestLotTypes>>([]);
  const [showNotification, setShowNotification] = useState<boolean>(false);

  useEffect(() => {
    if (!interestLots) return;
    if (isSelectedTrading) {
      setShowNotification(false);
      return;
    }

    const interestLotsIds: Array<number> = interestLots?.map((interestLot) => interestLot.lot);

    if (interestLotsIds?.length === 0) {
      setShowNotification(trading?.have_new_messages_lots?.length > 0);
      if (trading?.have_new_messages_lots?.[0] === null) setShowNotification(false);
    }

    if (
      monitoring.appeals_notifications.find(
        (appealNotification) => appealNotification.electronic_trading_id === trading.id,
      )
    )
      setShowNotification(true);

    if (trading?.have_new_messages) {
      setShowNotification(true);
      return;
    }

    interestLotsIds.forEach((interestLotsId) => {
      if (trading?.have_new_messages_lots.includes(interestLotsId)) {
        setShowNotification(true);
      }
    });
  }, [isSelectedTrading, interestLots, monitoring.appeals_notifications, trading]);

  useEffect(() => {
    setInterestLots(monitoring?.interest_lots[`${trading?.id}_${companyId(profile)}`]);
  }, [monitoring.interest_lots]);

  const isNullOrEmpty = (value: any) => {
    if (value === null) return true;
    if (value === undefined) return true;
    if (value.trim() === '') return true;

    return false;
  };

  const lastMessageTime = () => {
    if (isNullOrEmpty(trading?.last_message_time)) return 'Não iniciada';

    return `${moment(trading?.last_message_time).format('DD/MM/YYYY - k:mm')}`;
  };
  return (
    <Container>
      <div
        className={`trading-item list-group-item rounded border p-2 mb-2 list-group-item-action ${
          isSelectedTrading ? 'current' : ''
        } ${!isSelectedTrading && (showNotification ? 'text-dark' : 'text-black-50')}`}
        onClick={() => {
          toggleSelectedTrading(trading?.id);
          setShowNotification(false);
        }}
      >
        <div className="d-flex justify-content-between align-items-center mb-1">
          <strong className="mr-auto">{trading?.bidding?.edital || null}</strong>
          <span className="monitoring-date d-block">{lastMessageTime()}</span>
          <span
            className={`${
              showNotification ? 'd-block' : 'd-none'
            } ml-2 bg-danger monitoring-notification`}
          >
            Nova
          </span>
        </div>
        <span
          className="text-truncate d-inline-block monitoring-public-body"
          title={trading?.bidding?.public_body?.nome}
        >
          {trading?.bidding?.public_body?.nome}
        </span>
        <div className="d-flex align-items-center">
          <span
            className={`badge badge-${sourceData?.sourceClass} text-truncate d-inline-block`}
            style={{ maxWidth: '45%' }}
            title={sourceData?.label}
          >
            {sourceData?.label}
          </span>

          {trading?.trading_situation && (
            <span
              className="badge badge-secondary ml-1 text-truncate d-inline-block"
              style={{ maxWidth: '45%' }}
              title={trading?.trading_situation}
            >
              {trading?.trading_situation}
            </span>
          )}
          {showMonitoredByBalloon && (
            <MonitoredByBalloon
              monitoredByList={monitoredByList}
              tradingPosition={tradingPosition}
            />
          )}
          <div
            className={
              trading?.monitored_by_companies?.length
                ? 'ml-auto d-flex align-items-center'
                : 'ml-auto'
            }
          >
            <MonitoredByCompanies
              companies={trading?.monitored_by_companies || []}
              tradingPosition={tradingPosition}
            />
            <TradingDropdown
              isVisible={isSelectedTrading}
              bidding={trading?.bidding}
              archived={trading?.archived}
              important={trading?.important}
              lots={trading?.lots?.length < 1}
              id={trading?.id}
              monitoredBy={monitoredByList}
              companies={trading?.monitored_by_companies}
              onCompaniesChanged={onCompaniesChanged}
            />
          </div>
        </div>
      </div>
    </Container>
  );
};
export default TradingItem;
